class LandosBulkPricing extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.section = this.closest('.shopify-section');

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-bulk-quantity]');
      if (!button || !this.contains(button) || button.disabled) return;
      this.sync();
      if (button.disabled) return;

      const { selector, input } = this.quantityControl();
      selector.setValue(button.dataset.bulkQuantity);
      selector.onQuantityChange();
      selector.updateButtonStates();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      this.sync();
      this.querySelector('[data-bulk-status]').textContent = `Quantity set to ${input.value} ${this.dataset.unit}.`;
    }, options);

    for (const event of ['input', 'change', 'quantity-selector:update', 'variant:update']) {
      this.section?.addEventListener(event, () => {
        this.sync();
        // Variant updates can replace the form controls later in the same event.
        if (event === 'variant:update') requestAnimationFrame(() => this.isConnected && this.sync());
      }, options);
    }

    this.sync();
    customElements.whenDefined('quantity-selector-component').then(() => this.isConnected && this.sync());
  }

  disconnectedCallback() {
    this.abort?.abort();
  }

  quantityControl() {
    const form = this.section?.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"]`);
    const selector = form?.querySelector('quantity-selector-component');
    const input = selector?.querySelector('input[name="quantity"]');
    return { selector, input };
  }

  sync() {
    const { selector, input } = this.quantityControl();
    const ready = input && !input.disabled && typeof selector?.getCurrentValues === 'function';
    const values = ready ? selector.getCurrentValues() : null;
    const quantity = input?.valueAsNumber;

    for (const button of this.querySelectorAll('[data-bulk-quantity]')) {
      const minimum = Number(button.dataset.bulkQuantity);
      button.disabled = !ready || minimum < values.min || (minimum - values.min) % values.step !== 0 ||
        (values.max !== null && minimum + values.cartQuantity > values.max);
      const selected = ready && Number.isInteger(quantity) && quantity >= minimum && (minimum === 25 || quantity < 25);
      button.setAttribute('aria-pressed', String(Boolean(selected)));
    }
  }
}

if (!customElements.get('landos-bulk-pricing')) {
  customElements.define('landos-bulk-pricing', LandosBulkPricing);
}
